import { useState } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../api/client'
import type { EagleCI } from '../api/types'
import { useAsync } from '../hooks/useAsync'
import { t } from '../i18n/lingua'
import { ErrorBanner } from './common'

/**
 * Il gruppo di notifica e lo SLA di un CI monitorato (ADR-0022): due scelte
 * fra le anagrafiche di Eagle → Notifiche. Vuoto = nessuno: nessuno viene
 * avvisato, nessun impegno da misurare.
 */
export function EagleAssegnazione({
  ciId, dati, puoModificare, onDati,
}: { ciId: string; dati: EagleCI; puoModificare: boolean; onDati: (d: EagleCI) => void }) {
  const liste = useAsync(() => api.eagleNotify(), [])
  const [errore, setErrore] = useState<unknown>(null)
  const [invio, setInvio] = useState(false)
  const gruppi = liste.data?.groups ?? []
  const slas = liste.data?.slas ?? []
  const gruppo = gruppi.find((g) => g.id === dati.notify_group_id)
  const sla = slas.find((s) => s.id === dati.sla_id)

  async function cambia(parte: { notify_group_id?: string | null; sla_id?: string | null }) {
    setInvio(true)
    setErrore(null)
    try {
      onDati(await api.ciEagleAssegna(ciId, parte))
    } catch (e) {
      setErrore(e)
    } finally {
      setInvio(false)
    }
  }

  if (!liste.data) return null
  return (
    <div className="eagle-punti eagle-assegnazione">
      <ErrorBanner error={errore} />
      <label className="eagle-assegnazione__voce">
        <span><strong>{t('Avvisa')}</strong></span>
        {puoModificare ? (
          <select value={dati.notify_group_id ?? ''} disabled={invio} aria-label={t('Gruppo di notifica')}
                  onChange={(e) => void cambia({ notify_group_id: e.target.value || null })}>
            <option value="">{t('nessuno')}</option>
            {gruppi.map((g) => <option key={g.id} value={g.id}>{g.name}{g.enabled ? '' : ` (${t('spento')})`}</option>)}
          </select>
        ) : (
          <span>{gruppo?.name ?? t('nessuno')}</span>
        )}
      </label>
      <label className="eagle-assegnazione__voce">
        <span><strong>{t('SLA')}</strong></span>
        {puoModificare ? (
          <select value={dati.sla_id ?? ''} disabled={invio} aria-label={t('SLA')}
                  onChange={(e) => void cambia({ sla_id: e.target.value || null })}>
            <option value="">{t('nessuno')}</option>
            {slas.map((s) => <option key={s.id} value={s.id}>{s.name} · {s.availability_pct} %</option>)}
          </select>
        ) : (
          <span>{sla ? `${sla.name} · ${sla.availability_pct} %` : t('nessuno')}</span>
        )}
      </label>
      {gruppi.length === 0 && slas.length === 0 && (
        <span className="muted eagle-piccolo">
          {t('Gruppi e SLA si definiscono in')} <Link to="/eagle/notifiche">{t('Eagle → Notifiche')}</Link>.
        </span>
      )}
    </div>
  )
}
